var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4106_17094)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1082 6.68411C20.4134 6.37614 20.828 6.20148 21.2615 6.19829C21.695 6.19509 22.1121 6.36363 22.4217 6.66707C22.7314 6.9705 22.9083 7.38416 22.9138 7.81764C22.9194 8.25112 22.7531 8.66917 22.4513 8.98042L13.7204 19.8952C13.5704 20.0567 13.3894 20.1863 13.1883 20.2763C12.9871 20.3663 12.7698 20.4148 12.5494 20.4189C12.3291 20.4231 12.1101 20.3828 11.9057 20.3005C11.7013 20.2181 11.5155 20.0954 11.3595 19.9397L5.57084 14.1533C5.26323 13.8455 5.09047 13.4282 5.09058 12.993C5.09068 12.5579 5.26364 12.1406 5.5714 11.833C5.87916 11.5254 6.29651 11.3526 6.73164 11.3527C7.16678 11.3528 7.58405 11.5258 7.89166 11.8336L12.4698 16.4128L20.0648 6.73533C20.0786 6.71772 20.0935 6.70099 20.1094 6.68522L20.1082 6.68411Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4106_17094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
export default SvgSuccess;